package com.mgacreative.hotelru.feature.hotel.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import hotelos.shared.ui.designsystem.generated.resources.Res
import hotelos.shared.ui.designsystem.generated.resources.ic_logo
import hotelos.shared.ui.designsystem.generated.resources.ic_logo_white
import hotelos.shared.ui.designsystem.generated.resources.img_hotel_lobby_hero
import org.jetbrains.compose.resources.painterResource

@Composable
actual fun appLogoPainter(isDark: Boolean): Painter {
    return if (isDark) {
        painterResource(Res.drawable.ic_logo_white)
    } else {
        painterResource(Res.drawable.ic_logo)
    }
}

@Composable
actual fun hotelHeroPainter(): Painter {
    return painterResource(Res.drawable.img_hotel_lobby_hero)
}
